import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useOryUserLogin } from '../../../../ory/hooks/oryUserLogin/useOryUserLogin';
import { FormFieldNames, getMFAFormValidationSchema, IMFAFormData } from './validationScheme';

export interface IUseMFAFormProps {
  onSuccess?: () => void;
}

export function useMFAForm(props: IUseMFAFormProps) {
  const { formatMessage } = useIntl();
  const { finishLoginWithSecondFactor, isOryApiFetching } = useOryUserLogin();

  const formData = useForm<IMFAFormData>({
    defaultValues: { totpCode: '' },
    mode: 'onChange',
    resolver: yupResolver(getMFAFormValidationSchema(formatMessage)),
  });

  const formSubmit = async (data: IMFAFormData) => {
    await finishLoginWithSecondFactor(
      { totp: data.totpCode },
      { fieldName: FormFieldNames.TotpCode, formData },
      props.onSuccess
    );
  };

  return {
    formatMessage,
    formData,
    formSubmit,
    isOryApiFetching,
  };
}
